export default __webpack_public_path__ + "static/media/Marianne-Regular.4349f045.woff2";